import { CodeISO2 } from "@mindlercare/schema";
import { MarketSelector as MarketSelectorInternal } from "@mindlercare/ui-web";
import { useInternalAuth } from "../AuthenticationProvider";

export type MarketSelectorProps = {
  canSelectMarket: boolean;
  handleMarketSelect: (market: CodeISO2) => void;
};

export const MarketSelector = (props: MarketSelectorProps) => {
  const { market, switchMarket } = useInternalAuth();

  return (
    <MarketSelectorInternal
      currentMarket={market}
      allowSwitchRegions
      canSelectMarket={props.canSelectMarket}
      handleMarketSelect={({ codeISO2 }) => {
        switchMarket(codeISO2);
        props.handleMarketSelect(codeISO2);
      }}
    />
  );
};
